/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import SendIcon from "@mui/icons-material/Send";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import api from "../../services/api";
import { green } from "@mui/material/colors";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";

export function NewSuppliers() {
  const [circularLoading, setCircularLoading] = React.useState(false);
  const [requestError, setRequestError] = useState(false);
  const [requestErrorData, setRequestErrorData] = useState([]);
  const {
    register,
    reset,
    handleSubmit,
    //formState: { errors },
  } = useForm();

  const onSubmit = (supplier: any) => {
    setCircularLoading(true);
    supplier.quantity = Number(supplier.quantity);

    api
      .post("suppliers", supplier)
      .then((response) => {
        setCircularLoading(false);
        setRequestError(false);
        Swal.fire({
          title: "Suppliers created!",
          icon: "success",
          confirmButtonText: "Yes",
        });
        reset();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "" + error.response.data.message,
          footer: '<a href="">Why do I have this issue?</a>',
        });
        setCircularLoading(false);
        setRequestError(true); //trocado por false
        setRequestErrorData(error.response.data.message);
      });
  };

  const [country, setCountry] = useState("");
  const handleChangeCountry = (event: SelectChangeEvent) => {
    setCountry(event.target.value as string);
  };

  const [countries, setCountries] = React.useState<
    { id: number; name: string }[]
  >([]);
  const fetchCountry = async () => {
    const response = await api.get("countries");
    setCountries(response.data.items);
  };

  useEffect(() => {
    fetchCountry();
  }, []);

  return (
    <div>
      <Container component="main" maxWidth="lg">
        <Box
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginLeft: "20px",
          }}
        >
          {" "}
          <Typography
            component="h1"
            variant="h5"
            sx={{ fontSize: "32px", marginBottom: "15px", color: "#556cd6" }}
          >
            New Suppliers
          </Typography>
          {requestError && (
            <List component="nav" aria-label="erros">
              {requestErrorData.map((error) => (
                <ListItem key={error}>
                  <ListItemText
                    sx={{
                      color: "red",
                    }}
                    primary={error}
                  />
                </ListItem>
              ))}
            </List>
          )}
          <FormControl
            sx={{ m: 5, minWidth: 3 / 4 }} // equivalent to width: '75%' - usar fracao para %
            size="small"
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="name"
              type="string"
              label="Name"
              {...register("name", {})}
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="website"
              type="string"
              label="website"
              {...register("website", {})}
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="image"
              type="string"
              label="image"
              {...register("image", {})}
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="phone_number"
              type="string"
              label="phone_number"
              {...register("phone_number", {})}
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              type="string"
              label="email"
              {...register("email", {})}
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="responsible_salesperson"
              type="string"
              label="responsible_salesperson"
              {...register("responsible_salesperson", {})}
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="country_id"
              type="string"
              label="Location"
              {...register("location", {})}
              autoFocus
            />

            <Box>
              <FormControl fullWidth>
                <InputLabel id="country-label">Country</InputLabel>
                <Select
                  labelId="country-select-label"
                  id="country"
                  value={country}
                  {...register("country_id")}
                  label="country"
                  onChange={handleChangeCountry}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {countries.map((country, index) => (
                    <MenuItem value={country.id} key={index}>
                      {country.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                minWidth: 3 / 4,
                marginBottom: "30px",
              }}
            >
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  mt: 2,
                }}
              >
                <Button
                  sx={{ marginLeft: "40px" }}
                  onClick={() => reset()}
                  variant="outlined"
                  startIcon={<DeleteIcon />}
                >
                  Clear
                </Button>
                <Button
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                  size="large"
                  endIcon={<SendIcon />}
                  disabled={circularLoading}
                  type="submit"
                >
                  Send
                  {circularLoading && (
                    <CircularProgress
                      size={24}
                      sx={{
                        color: green[500],
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: "-12px",
                        marginLeft: "-12px",
                      }}
                    />
                  )}
                </Button>
              </Stack>
            </Box>
          </FormControl>
        </Box>
      </Container>
    </div>
  );
}
